module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M15.543 31.946A1.998 1.998 0 0 1 14.001 30V18.999a1 1 0 0 0-1-1H2a2.002 2.002 0 0 1-1.948-1.54 2.004 2.004 0 0 1 1.054-2.25L29.108.208a2 2 0 1 1 2.684 2.684L17.791 30.894a2.004 2.004 0 0 1-2.248 1.052z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/location-arrow-1.js
// module id = 1237
// module chunks = 14